import React, { useEffect, useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";

const ProtectedMenuRoute = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const isDashboard = currentPath === "/dashboard" || currentPath.startsWith("/dashboard/");

  const rawRole = sessionStorage.getItem("role") || sessionStorage.getItem("userRole") || "";
  const userRole = rawRole.toLowerCase().trim();
  const isL4 = userRole === "l4";

  const defaultRoute = useMemo(() => {
    if (["l0", "l1", "l2", "l3"].includes(userRole)) {
      return "/dashboard";
    } else if (isL4) {
      return "/audit";
    }
    return "/provider";
  }, [userRole, isL4]);

  const storedMenusStr = sessionStorage.getItem('userMenus');

  const menuItems = useMemo(() => {
    if (!storedMenusStr) return [];
    try {
      return JSON.parse(storedMenusStr);
    } catch {
      return [];
    }
  }, [storedMenusStr]);

  // L4 has access to ALL routes
  const hasAccess = useMemo(() => {
    if (isL4 || isDashboard) return true;

    return menuItems.some((menu) => {
      const allowedPath = (menu.path || "").toLowerCase();
      if (!allowedPath || allowedPath === "/") return false;
      return currentPath.startsWith(allowedPath);
    });
  }, [isL4, isDashboard, menuItems, currentPath]);

  useEffect(() => {
    if (!isL4 && storedMenusStr && !hasAccess && !isDashboard) {
      toast.error("You do not have permission to view this page for the selected account.");
    }
  }, [isL4, hasAccess, isDashboard, storedMenusStr]);

  // Always allow L4 or Dashboard
  if (isL4 || isDashboard) {
    return <Outlet />;
  }

  if (!storedMenusStr) {
    if (currentPath === defaultRoute.toLowerCase()) {
      return <Navigate to="/provider" replace />;
    }
    return <Navigate to={defaultRoute} replace />;
  }

  if (!hasAccess) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
};

export default ProtectedMenuRoute;